import { render } from "./ProgressRing.vue?vue&type=template&id=0a7a98c6&scoped=true"
import script from "./ProgressRing.vue?vue&type=script&lang=js"
export * from "./ProgressRing.vue?vue&type=script&lang=js"

import "./ProgressRing.vue?vue&type=style&index=0&id=0a7a98c6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Raska\\Desktop\\raska\\projekat\\astra\\astra-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7a98c6"]])

export default __exports__